import * as React from 'react';
import { useAppSelector } from 'src/store/hooks';

const FeasibilityQuestionnaires: React.FunctionComponent<any> = () => {
  const showCMPArr: any = useAppSelector(state => state.feasibility.showCMPArr);
  return (
    <>
      {showCMPArr.map((ele: any) => (
        <>{ele.curruntlyActive ? <ele.cmp item={ele} /> : null}</>
      ))}
    </>
  );
};
export default FeasibilityQuestionnaires;
